<template>
  <div>
    <b-input-group size="sm" v-if="!nodims">
      <b-input :disabled="readonly" type="number" ref="L" v-model="package.pkg_length" :autofocus="autofocus" size="sm" class="text-right" :state="state.pkg_length | state"
               @keydown.native="(e) => keydown(e) && $refs.W.focus()"/>
      <b-input-group-append>
        <b-input-group-text>" L</b-input-group-text>
      </b-input-group-append>
      <b-input :disabled="readonly" type="number" ref="W" v-model="package.pkg_width" size="sm" class="text-right" :state="state.pkg_width | state"
               @keydown.native="(e) => keydown(e) && $refs.H.focus()"/>
      <b-input-group-append>
        <b-input-group-text>" W</b-input-group-text>
      </b-input-group-append>
      <b-input :disabled="readonly" type="number" ref="H" v-model="package.pkg_height" size="sm" class="text-right" :state="state.pkg_height | state"
               @keydown.native="(e) => keydown(e) && $refs.We.focus()"/>
      <b-input-group-append>
        <b-input-group-text>" H</b-input-group-text>
      </b-input-group-append>
    </b-input-group>

    <b-input-group size="sm" class="mt-1">
      <b-input :disabled="readonly" ref="We" type="number" v-model="package.pkg_weight" size="sm" class="text-right" :state="state.pkg_weight | state"
               @keydown.native="(e) => keydown(e) && $emit('next')"/>
      <b-input-group-append>
        <b-input-group-text>lbs</b-input-group-text>
      </b-input-group-append>
      <b-input-group-append v-if="$store.state.settings.defaults.scales && !readonly">
        <b-dropdown size="sm">
          <template #button-content>
            <font-awesome-icon icon="fa-solid fa-balance-scale"/>
          </template>
          <b-dropdown-item @click="scaleRead(scale)" v-for="scale in $store.state.settings.defaults.scales" :key="scale.value">
            Scale: {{ scale }}
          </b-dropdown-item>
        </b-dropdown>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: "form-weight-dims",
  props: {
    value: Object,
    autofocus: Boolean,
    nodims: Boolean,
    readonly: Boolean,
    state: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      package: this.value
    }
  },
  watch: {
    package(v) {
      this.$emit('input', v)
    },
    value(v) {
      this.package = v
    }
  },
  methods: {
    focus() {
      this.$refs.L.focus()
    },
    keydown(event) {
      return event.which === 13
    },
    scaleRead(scale) {
      this.asyncAction('/api/scale?scale=' + scale, 'GET').then(({weight}) => {
        this.$set(this.package, 'pkg_weight', weight)
      })
    },
  }
}
</script>

<style scoped>

</style>